// Brouillons de chat façon WhatsApp : le texte tapé est gardé PAR conversation (cache localStorage) et suit le
// membre sur ses autres appareils (lot 569 : copie serveur, « le plus récent gagne »). Vidé à l'envoi.
import { api } from "@/lib/api";

export const CHAT_DRAFTS_KEY = "yalola.chatDrafts";
export const CHAT_DRAFT_EVENT = "yalola:chatdraft";
const MAX_DRAFTS = 50;
const MAX_LEN = 2000;
const PUSH_DELAY_MS = 800;
const SYNC_MIN_INTERVAL_MS = 30_000;

export const dmDraftKey = (peerId) => (peerId ? `dm:${peerId}` : "");
export const groupDraftKey = (groupId) => (groupId ? `group:${groupId}` : "");

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(CHAT_DRAFTS_KEY) || "null"); return v && typeof v === "object" ? v : {}; }
  catch { return {}; }
};
const write = (all) => {
  try {
    const entries = Object.entries(all).sort((a, b) => (a[1].at || 0) - (b[1].at || 0)).slice(-MAX_DRAFTS);
    localStorage.setItem(CHAT_DRAFTS_KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch { /* noop */ }
  try { window.dispatchEvent(new CustomEvent(CHAT_DRAFT_EVENT)); } catch { /* noop */ }
};

export const getChatDraft = (key) => (key ? (read()[key]?.text || "") : "");

// ── Copie serveur ────────────────────────────────────────────────────────────────────────────────────────────
const timers = new Map();
const pushNow = async (key) => {
  timers.delete(key);
  const e = read()[key];
  const body = { key, text: e?.text || "", at: e?.at || Date.now() };
  try {
    await api.post("/chat/drafts", body);
    if (e) { const all = read(); if (all[key] && all[key].at === e.at) { all[key].pushed = true; write(all); } }
  } catch { /* hors ligne ou déconnecté : le cache local reste, re-poussé à la prochaine synchro */ }
};
const schedulePush = (key, immediate = false) => {
  clearTimeout(timers.get(key));
  if (immediate) { pushNow(key); return; }
  timers.set(key, setTimeout(() => pushNow(key), PUSH_DELAY_MS));
};
export const flushChatDrafts = () => { for (const key of [...timers.keys()]) { clearTimeout(timers.get(key)); pushNow(key); } };

export const setChatDraft = (key, text) => {
  if (!key) return;
  const all = read();
  const clean = String(text || "");
  if (!clean.trim()) { if (!(key in all)) return; delete all[key]; write(all); schedulePush(key, true); return; }
  all[key] = { text: clean.slice(0, MAX_LEN), at: Date.now() };
  write(all);
  schedulePush(key);
};

export const clearChatDraft = (key) => setChatDraft(key, "");

let lastSyncAt = 0;
let syncing = null;
// Récupère les brouillons du serveur et fusionne (le plus récent gagne) ; pousse ceux que cet appareil n'a jamais envoyés ;
// retire ceux effacés ailleurs (poussés jadis, absents du serveur). Au plus une fois toutes les 30 s, sauf `force`.
export const syncChatDrafts = async ({ force = false } = {}) => {
  if (syncing) return syncing;
  if (!force && Date.now() - lastSyncAt < SYNC_MIN_INTERVAL_MS) return null;
  syncing = (async () => {
    try {
      const { data } = await api.get("/chat/drafts");
      const remote = data?.drafts || {};
      const all = read();
      let changed = false;
      for (const [key, r] of Object.entries(remote)) {
        const l = all[key];
        if (!l || (r.at || 0) > (l.at || 0)) { all[key] = { text: r.text, at: r.at || Date.now(), pushed: true }; changed = true; }
      }
      for (const [key, l] of Object.entries(all)) {
        if (remote[key]) continue;
        if (l.pushed) { delete all[key]; changed = true; } // effacé (ou envoyé) depuis un autre appareil
        else schedulePush(key, true);
      }
      if (changed) write(all);
      lastSyncAt = Date.now();
      return all;
    } catch { return null; }
    finally { syncing = null; }
  })();
  return syncing;
};

if (typeof window !== "undefined") window.addEventListener("pagehide", flushChatDrafts); // fermeture d'onglet / arrière-plan : on pousse ce qui attend

// Déconnexion : le cache local ne doit pas passer au compte suivant sur cet appareil.
export const resetChatDraftsCache = () => { for (const t of timers.values()) clearTimeout(t); timers.clear(); lastSyncAt = 0; try { localStorage.removeItem(CHAT_DRAFTS_KEY); } catch { /* noop */ } };

// Aperçu pour la liste des conversations : première ligne, sans sauts de ligne.
export const draftPreview = (text) => String(text || "").replace(/\s+/g, " ").trim();
